class HaciendolaMegaMenu extends HTMLElement {
  constructor() {
    super()
    const menuItems = [
      ...document.querySelectorAll('header .header__inline-menu > ul > li'),
    ]
    this.debounce = undefined
    this.stickyHeader = document.querySelector('sticky-header')
    this.label = this.dataset.trigger.trim()
    this.linkTitle = this.label.toLowerCase()
    this.summary = undefined
    this.megaMenuColumns = [...this.querySelectorAll('.h-megamenu__column')]
    this.menuLinks = [...this.querySelectorAll('.h-megamenu__list-link')]
    this.linkImages = [...this.querySelectorAll('.h-megamenu__list-image')]
    this.lastColumn = this.megaMenuColumns[this.megaMenuColumns.length - 1]

    this.menuLinks.forEach((link) => {
      const cover = link.dataset.cover
      const description = link.dataset.coverDescription
      if(!cover) return

      this.lastColumn.innerHTML += `
      <div class="h-megamenu__list-image" data-cover="${cover}">
        <img style="max-width: 625px;" src="${cover}" srcset=""/>
        <p class="h-megamenu__list-description"> <span class="h-megamenu__list-description-dot"></span>${description}</p>         
      </div>
      `

      link.addEventListener('mouseover', () => {
        const active = this.lastColumn.querySelector('.active')
        const current = this.lastColumn.querySelector(`[data-cover="${cover}"]`)
        if(active) active.classList.remove('active')
        if(current) current.classList.add('active')
      })

    })


    this.trigger = menuItems.find(item => {
      const summary = item.querySelector('.header__menu-item')
      const search = (summary || item).textContent.toLowerCase().trim()
      const isItem = search === this.linkTitle
      if (summary) this.summary = summary
      if (isItem && summary && summary.nextElementSibling){
        summary.nextElementSibling.remove()
      }
      
      return isItem
    })
    

    menuItems.forEach(item => {
      if (item === this.trigger || item.megaMenu) return
      item.addEventListener('mouseenter', (e) => {
        // this.hide(null, false)
      })
    })

    this.enableCaret = this.dataset.enableCaret === 'true' ? true : false
    this.parent = this.trigger.closest('header')
    if (this.trigger) {
      this.trigger.megaMenu = this
      const lnk =
        this.trigger.querySelector('a') || this.trigger.querySelector('summary')
      lnk.style.display = 'flex'
      lnk.style.gap = '.3em'
      lnk.style.alignItems = 'center'
      this.parent.appendChild(this)
      if (this.classList.contains('h-megamenu--fullwidth')) {
        this.style.width = `${window.innerWidth}px`
      }

      this.trigger.addEventListener('click', e => {
        // e.preventDefault()
      })

      // this.trigger.addEventListener('click', e => this.hide(e))
      this.trigger.addEventListener('mouseenter', () => this.show())

      this.addEventListener('mouseenter', () => this.show())
      this.addEventListener('mouseleave', e => this.hide(e, false), false)
      const linkTrigger =  this.trigger.querySelector('.header__menu-item')
      if(linkTrigger){
        linkTrigger.hasMegaMenu = true
      }
    }
  }

  show(){
    const openedMM = this.parent.openedMM
    if(openedMM && openedMM !== this) openedMM.hide(null, false)
    this.parent.openedMM = this
    const top = this.trigger.offsetTop + this.trigger.offsetHeight
    this.style.setProperty('--top-position', `${top}px`)
    this.style.display = 'grid'
    this.trigger.classList.add('h-megamenu--trigger')
  }

  hide(e){
    this.parent.openedMM = undefined
    this.style.display = 'none'
    this.trigger.classList.remove('h-megamenu--trigger')
    if(e && e.target == this){
      this.stickyHeader.hideUnderline()
    }
  }

  // show2() {
  //   const openedMM = this.parent.openedMM
  //   if (openedMM && openedMM !== this) openedMM.hide(null,false)
  //   console.log("showFunction", openedMM)
  //   this.parent.openedMM = this
  //   const top = this.trigger.offsetTop + this.trigger.offsetHeight
  //   this.style.setProperty('--top-position', `${top}px`)
  //   this.style.display = 'grid'
  //   this.trigger.classList.add('h-megamenu--trigger')
  // }

  // hide2(e, hideUnderline = true) {
  //   console.log("hide", e)
  //   if (!e || e.target === this || e.target === this.trigger) {
  //     console.log("cerrando", this)
  //     this.style.display = 'none'
  //     this.trigger.classList.remove('h-megamenu--trigger')
  //     if(hideUnderline){
  //       this.parent.closest('sticky-header').hideUnderline()
  //     }
  //     this.parent.openedMM = undefined
  //     if(this.debounce){
  //       clearTimeout(this.debounce)
  //     }
  //     this.debounce = setTimeout(() => {
  //       if(this.stickyHeader.trigger == this.trigger) {
  //         this.stickyHeader.hideUnderline()
  //       }
  //     },100)
  //   }
  // }
}

customElements.define('h-megamenu', HaciendolaMegaMenu)
